import React, { useCallback } from "react";
import { useNavigate } from "react-router";
import { AccountMenuItem } from "./accountMenu.model";
import { useAuthStore } from "@companion-core/shared/app/Store/authStore";
import "@companion-core/web/src/Assets/Styles/scss/accountMenu.scss";

interface AccountMenuDropdownProps {
  items: AccountMenuItem[];
}

export const AccountMenuDropdown = ({ items }: AccountMenuDropdownProps) => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const performLogout = useCallback(() => {
    logout();
    navigate("login");
  }, [logout, navigate]);

  return (
    <ul className="ant-dropdown-menu">
      {items?.map((item, index) => (
        <li
          className="ant-dropdown-menu-item"
          key={index}
          onClick={() => (item.name === "logout" ? performLogout() : navigate(item.name))}>
          <div className="ant-dropdown-menu-item-container">
            <span className="ant-dropdown-menu-item-icon">{item?.icon}</span>
            <span className="ant-dropdown-menu-title-content">{item?.label}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};
